
import { CompanySettingsCard } from "./CompanySettingsCard"

export function CompanySettings() {
  return <CompanySettingsCard />
}
